import React from "react";
import "./_loader.scss";

const Loader = () => (
  <div className="wizard__loader"></div>
);

export default Loader;
